import * as RadixTooltipPrimitive from '@radix-ui/react-tooltip';

export const TooltipProvider = RadixTooltipPrimitive.Provider;
